import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const AboutSection = () => {
  const features = [
    { icon: 'Award', title: '20年專業經驗', desc: '擁有豐富的飯店與賞鯨服務經歷，最懂旅客需求。' },
    { icon: 'Smile', title: '貼心專人服務', desc: '以最在地、最熱情的態度，為您解說每一處風景。' },
    { icon: 'Map', title: '深度生態導覽', desc: '專業解說人員帶您一窺大自然奧妙及鬼斧神工。' },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
              宜蘭好山好水 <br/>
              <span className="text-blue-600">生態龜山島之旅</span>
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              本公司慶祝20週年舉辦【鯨夏一跳】活動，凡參加賞鯨、登龜山島優惠特價中，401船位目前均尚有空位！
            </p>
            <p className="text-slate-600 mb-8 leading-relaxed">
              炎炎夏天，來感受大海氣息，看看波濤洶湧的太平洋。心情鬱卒時吹吹海風，可以平衡情緒，消除壓力。誠心誠意邀請您來宜蘭，把蘭陽的好山、好水、好吃的小吃呈現給您，保證滿載而歸！
            </p>
            
            <div className="space-y-6">
              {features.map((item, index) => (
                <div key={index} className="flex items-start">
                  <div className="flex-shrink-0 h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center">
                    <SafeIcon name={item.icon} className="text-blue-600 text-xl" />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold text-slate-800">{item.title}</h3>
                    <p className="mt-1 text-slate-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="aspect-w-4 aspect-h-5 rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1559128010-7c1ad6e1b6a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" 
                alt="龜山島風景" 
                className="object-cover w-full h-full"
              />
            </div>
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl max-w-xs border border-slate-100">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                  <SafeIcon name="Star" className="text-orange-500 text-xl" />
                </div>
                <div>
                  <p className="text-sm text-slate-500 font-medium">現正熱賣中</p>
                  <p className="text-lg font-bold text-slate-800">401高地登島名額</p>
                </div>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;